import axios from './axios';

// Dosyayı multipart yerine ham gövde olarak gönderir; diğer alanlar query string'de gider.
const rawUpload = (url, file, params = {}) => {
    if (!file) {
        return Promise.reject(new Error('Dosya seçilmedi'));
    }

    return axios.post(url, file, {
        params,
        headers: {
            'Content-Type': file.type || 'application/octet-stream',
            'X-Filename': encodeURIComponent(file.name),
        },
    });
};

export default rawUpload;
